import { render, staticRenderFns } from "./AiMaterialsTab.vue?vue&type=template&id=68eaa1ea&scoped=true&"
import script from "./AiMaterialsTab.vue?vue&type=script&lang=js&"
export * from "./AiMaterialsTab.vue?vue&type=script&lang=js&"
import style0 from "./AiMaterialsTab.vue?vue&type=style&index=0&id=68eaa1ea&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eaa1ea",
  null
  
)

export default component.exports